import { AnalyticsStore } from 'bernie-plugin-mobx';
import { comparer } from 'mobx';
import { isEqual } from 'lodash';

import { merge, updateSearch } from 'bernie-core';

import { History, Location } from 'history';
import { LodgingPwaPropertySearchQueryVariables } from 'src/common/__generated__/api';

export const handleMapTrigger = (history: History, location: Location, analytics?: AnalyticsStore) => () => {
  updateSearch({ history, location, newParams: { pwaOverlay: 'map' } });
  if (analytics && typeof analytics.trackEvent === 'function') {
    analytics.trackEvent('Module.MapOpen.Link', 'Launch dynamic map', null);
  }
};

type DynamicSearchMapInputs = Omit<LodgingPwaPropertySearchQueryVariables, 'context'>;
const { withoutKeys, flattenFields, allKeys } = merge;
export const calculateNewMapInputs = (prevState: DynamicSearchMapInputs, newState: DynamicSearchMapInputs) => {
  const [prevStateWithoutDestination, newStateWithoutDestination] = [
    withoutKeys(untrackedDestinationKeys).merge({}, flattenFields(prevState)),
    withoutKeys(untrackedDestinationKeys).merge({}, flattenFields(newState)),
  ];
  const statesAreNotEqual = !isEqual(prevStateWithoutDestination, newStateWithoutDestination);
  const newStateHasSearchId = newState.criteria?.secondary?.selections?.find(selection => selection.id === 'searchId');
  if (statesAreNotEqual && newStateHasSearchId) {
    return newState;
  }

  const [prevDestination, newDestination] = [prevState?.criteria?.primary.destination, newState.criteria?.primary.destination];
  const coordsAreEqual = comparer.structural(
    allKeys().merge({}, prevDestination?.coordinates),
    allKeys().merge({}, newDestination?.coordinates)
  );
  const regionNamesAreEqual = prevDestination?.regionName === newDestination?.regionName;
  const newRegionId = newState.criteria?.primary?.destination?.regionId;

  /*
    1)We only want to initialize a render whenever the regionId is calulated by property listing
    to prevent the map from re-rendering twice on map pan.

    2)Due to the way dialog context and the universal search form compete to update the URL we should only render
    the map whenever we see that the regionNames are different; preventing the double render of the map caused by the universal search form's destination input changing.
  */

  if ((coordsAreEqual && newRegionId !== null) || (coordsAreEqual && !regionNamesAreEqual)) {
    return prevState;
  }

  return newStateHasSearchId ? newState : prevState;
};

export const untrackedDestinationKeys = [
  'criteria_primary_destination_regionName',
  'criteria_primary_destination_regionId',
  'criteria_primary_destination_coordinates',
  'criteria_primary_destination_pinnedPropertyId',
  'criteria_primary_destination_propertyIds',
  'criteria_primary_destination_mapBounds',
  'criteria_primary_destination_coordinates_latitude',
  'criteria_primary_destination_coordinates_longitude',
];
